// A signature as a document is stamped with: a PNG (data url) with a
// transparent background, cut to the ink with a little margin around it, no
// bigger than it needs to be — and under the size a server takes (aldoo-na's
// payout contracts take a data url of up to 400 KB; 300 KB leaves room).

const INK_ALPHA = 10

/** The box of the pixels with ink in them: { x, y, width, height }, or null for an empty canvas. */
function inkBox(canvas) {
  const { width, height } = canvas
  if (!width || !height) return null
  const data = canvas.getContext("2d").getImageData(0, 0, width, height).data
  let minX = width
  let minY = height
  let maxX = -1
  let maxY = -1
  for (let y = 0; y < height; y++) {
    const row = y * width * 4
    for (let x = 0; x < width; x++) {
      if (data[row + x * 4 + 3] <= INK_ALPHA) continue
      if (x < minX) minX = x
      if (x > maxX) maxX = x
      if (y < minY) minY = y
      if (y > maxY) maxY = y
    }
  }
  if (maxX < 0) return null
  return { x: minX, y: minY, width: maxX - minX + 1, height: maxY - minY + 1 }
}

/**
 * The PNG of what is drawn on `source` (a canvas with a transparent
 * background): trimmed, at most `maxWidth` × `maxHeight`, scaled down further
 * until its data url is at most `maxChars` long. null when nothing is drawn.
 */
export function signaturePng(source, { maxWidth = 900, maxHeight = 300, maxChars = 300 * 1024 } = {}) {
  const box = inkBox(source)
  if (!box) return null
  const margin = Math.round(Math.max(box.width, box.height) * 0.04) + 4
  const fullWidth = box.width + margin * 2
  const fullHeight = box.height + margin * 2
  let scale = Math.min(1, maxWidth / fullWidth, maxHeight / fullHeight)
  for (;;) {
    const out = document.createElement("canvas")
    out.width = Math.max(1, Math.round(fullWidth * scale))
    out.height = Math.max(1, Math.round(fullHeight * scale))
    const context = out.getContext("2d")
    context.imageSmoothingEnabled = true
    context.imageSmoothingQuality = "high"
    context.drawImage(source, box.x, box.y, box.width, box.height, margin * scale, margin * scale, box.width * scale, box.height * scale)
    const url = out.toDataURL("image/png")
    out.width = 0
    if (url.length <= maxChars || fullWidth * scale < 120) return url
    scale *= 0.8
  }
}
